module.exports = __webpack_public_path__ + "static/media/image 30.3ec82ba3.png";